var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Tooltip } from '../Tooltip';
var TIME_TO_AUTO_CLOSE = 1500; //ms
export var TextToCopy = function (_a) {
    var textToCopy = _a.textToCopy, children = _a.children, _b = _a.timeToAutoClose, timeToAutoClose = _b === void 0 ? TIME_TO_AUTO_CLOSE : _b, props = __rest(_a, ["textToCopy", "children", "timeToAutoClose"]);
    var _c = useState(false), isVisible = _c[0], setIsVisible = _c[1];
    var handleOnClick = function () {
        if (textToCopy) {
            navigator.clipboard.writeText(textToCopy).then(function () {
                setIsVisible(true);
                setTimeout(function () {
                    setIsVisible(false);
                }, timeToAutoClose);
            });
        }
        else {
            // eslint-disable-next-line no-console
            console.error('No "textToCopy" prop or undefined => TextToCopy component');
        }
    };
    return (_jsx(Tooltip, __assign({ visibleState: isVisible, content: "Copied" }, props, { onClick: handleOnClick }, { children: children })));
};
